import { FC, memo, useState } from 'react';
import { CommunicationTrait } from 'types/register';

import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { ButtonsSet } from 'modules/RegisterModule/components/ButtonsSet';
import { OptionsGroup } from 'modules/RegisterModule/components/OptionsGroup';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { getTruncatedText } from 'modules/RegisterModule/helpers';

export interface Step4Props {
  onSubmit: (communicationTrait: CommunicationTrait) => void;
  prevStep: () => void;
  employeeName: string;
  communicationTrait: string;
}

export const Step4: FC<Step4Props> = memo(
  ({ onSubmit, prevStep, employeeName, communicationTrait }) => {
    const optionToCommunicationTrait: Record<string, CommunicationTrait> = {
      'Be formal': 'formal',
      'Be funny': 'funny',
      'Be friendly': 'friendly',
    };

    const { isUpTablet } = useBreakpoints();

    const [selectedTrait, setSelectedTrait] = useState(
      Object.keys(optionToCommunicationTrait).find(
        (key) => optionToCommunicationTrait[key] === communicationTrait
      ) || ''
    );

    const handleGenderChange = (value: string) => {
      setSelectedTrait(value);
    };

    return (
      <Box className="flex flex-1 flex-col items-center justify-center">
        <Typography
          variant="pSemiBold"
          className="mt-8 max-w-[44rem] break-words text-center text-[28px] md:text-[32px]"
        >
          How should {getTruncatedText(isUpTablet, employeeName)} communicate?
        </Typography>
        <OptionsGroup
          data={Object.keys(optionToCommunicationTrait)}
          onClick={handleGenderChange}
          selectedValue={selectedTrait}
        />
        <ButtonsSet
          onBack={prevStep}
          onNext={() => onSubmit(optionToCommunicationTrait[selectedTrait])}
        />
      </Box>
    );
  }
);
